// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-of {
    white-space: nowrap;
}
.page-of{
    color:var(--color-text-dark);
    font-weight: 700;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif; 
}
.page-of .page-link {
    padding: 0.25rem 0.75rem;
}
.pagination .page-item .page-link{
    border:none;
}
.page-link{
    color:#000 !important;
    background-color: transparent !important;
}
.result-count {
    font-weight: 700;
    color: var(--color-text-dark);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
    padding: 0.25rem 0.75rem;
}
.paging{
    color:var(--color-text-dark);
    font-weight: 700;
    font-family: "agGridAlpine";
    font-size: 16px;
    line-height: 16px;
    font-style: normal;
    font-weight: normal;
    font-feature-settings: normal;
    font-variant: normal;
    text-transform: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.paging.next *::before {
    content: "\\f11f";
    font-size: 1.25rem;
    font-weight: bolder;
}
.paging.last *::before{
    content: "\\f118";
    font-size: 1.5rem;
    font-weight: bolder;
}
.paging.first *::before{
    content: "\\f115";
    font-size: 1.5rem;
    font-weight: bolder;
}
.paging.previous *::before{
    content: "\\f125";
    font-size: 1.25rem;
    font-weight: bolder;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/TablePaging.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,gIAAgI;AACpI;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,wCAAwC;AAC5C;AACA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,gIAAgI;IAChI,wBAAwB;AAC5B;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;IACpB,oBAAoB;IACpB,mCAAmC;IACnC,kCAAkC;AACtC;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":[".page-of {\n    white-space: nowrap;\n}\n.page-of{\n    color:var(--color-text-dark);\n    font-weight: 700;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif; \n}\n.page-of .page-link {\n    padding: 0.25rem 0.75rem;\n}\n.pagination .page-item .page-link{\n    border:none;\n}\n.page-link{\n    color:#000 !important;\n    background-color: transparent !important;\n}\n.result-count {\n    font-weight: 700;\n    color: var(--color-text-dark);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n    padding: 0.25rem 0.75rem;\n}\n.paging{\n    color:var(--color-text-dark);\n    font-weight: 700;\n    font-family: \"agGridAlpine\";\n    font-size: 16px;\n    line-height: 16px;\n    font-style: normal;\n    font-weight: normal;\n    font-feature-settings: normal;\n    font-variant: normal;\n    text-transform: none;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.paging.next *::before {\n    content: \"\\f11f\";\n    font-size: 1.25rem;\n    font-weight: bolder;\n}\n.paging.last *::before{\n    content: \"\\f118\";\n    font-size: 1.5rem;\n    font-weight: bolder;\n}\n.paging.first *::before{\n    content: \"\\f115\";\n    font-size: 1.5rem;\n    font-weight: bolder;\n}\n.paging.previous *::before{\n    content: \"\\f125\";\n    font-size: 1.25rem;\n    font-weight: bolder;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
